import {ACTION_BUTTON_Z_INDEX} from '@components/game-room/ActionButtons';
import {EMOJI_TRANSITION_DURATION} from '@constant/game';
import {TABLE_AREA_Z_INDEX} from '@constant/system';

const commonPlayerStyle = {
  // TODO debug
  // background: 'grey',
  zIndex: TABLE_AREA_Z_INDEX.PLAYER_IN_TABLE,
};

const TABLE_HEIGHT = 448;
const TABLE_WIDTH = 285;

// const TABLE_IMAGE_HEIGHT = 600;
// const TABLE_IMAGE_WIDTH = 400;
// original: 794x975
const TABLE_IMAGE_WIDTH = 437;
const TABLE_IMAGE_HEIGHT = 537;

const TABLE_HEIGHT_DESKTOP = 456;
const TABLE_WIDTH_DESKTOP = 680;

const EMOJI_SELECTOR_OFFSET = {
  HEIGHT: 40,
  WIDTH: 50,
};
// TODO

const desktop = theme => {
  const {toVW} = theme;
  return {
    tableArea: {
      // original:
      // width: TABLE_WIDTH_DESKTOP,
      // // width: `min(${TABLE_WIDTH_DESKTOP}px, 80%)`,
      // height: 'fit-content',
      width: TABLE_WIDTH_DESKTOP,
      // TODO *** maybe buggy
      height: TABLE_HEIGHT_DESKTOP,
    },
    neonTable: {
      // TODO *** maybe buggy
      // original:
      //  // width: `min(${TABLE_WIDTH_DESKTOP}px, 80%)`,
      //  width: '100%',
      //  // width: TABLE_WIDTH_DESKTOP,
      //  height: TABLE_HEIGHT_DESKTOP,
      //  position: 'relative',
      //  top: '0px',
      //  left: '0px',
      width: TABLE_WIDTH_DESKTOP,
      height: TABLE_HEIGHT_DESKTOP,
      position: 'relative',
      top: '0px',
      left: '0px',
    },
    dealerButton: {
      '&.position_0': {
        top: '71%',
        left: '42%',
        bottom: 'unset',
      },
      '&.position_1': {
        top: '67%',
        left: '15%',
        bottom: 'unset',
      },
      '&.position_2': {
        top: '33%',
        left: '15%',
      },
      '&.position_3': {
        top: '21%',
        left: '57%',
        right: 'unset',
      },
      '&.position_4': {
        top: '33%',
        left: '80%',
      },
      '&.position_5': {
        top: '67%',
        left: '80%',
        bottom: 'unset',
      },
    },
    cardsOnTable: {
      top: '196px',
      left: '52.5%',
      width: '41%',
      height: 'fit-content',
    },
    bottomLeft: {
      left: '2%',
      top: '52%',
    },
    middleLeft: {
      top: '17%',
      left: '2%',
    },
    topMiddle: {
      top: '1%',
      left: '50%',
      transform: 'translate(-50%, 0)',
      right: 'unset',
    },
    middleRight: {
      right: '2%',
      top: '17%',
    },
    bottomRight: {
      right: '2%',
      top: '52%',
    },
    bottomMiddle: {
      top: 'unset',
      bottom: '0.87%',
      left: '50%',
      transform: 'translate(-50%, 0)',
    },
    emojiTargetDescription: {
      marginTop: '100px',
    },
    emojiTargetSelector: {
      // width: `min(${TABLE_WIDTH_DESKTOP}px, 80%)`,
      width: TABLE_WIDTH_DESKTOP,
      height: '100%',
    },
    emojiTargetButton: {
      '&.position0': {
        left: 305,
        bottom: -10,
      },
      '&.position1': {
        top: 270,
        left: 14,
      },
      '&.position2': {
        top: 113,
        left: 13,
      },
      '&.position3': {
        top: 0,
        left: 305,
      },
      '&.position4': {
        top: 113,
        right: 13,
      },
      '&.position5': {
        right: 14,
        top: 270,
      },
    },
    outcardsOnTable: {
      top: '13%',
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    // for positioning player icons
    tableArea: {
      // *** original:
      // position: 'relative',
      // width: TABLE_WIDTH,
      // height: TABLE_HEIGHT,
      position: 'relative',
      width: TABLE_IMAGE_WIDTH,
      height: TABLE_IMAGE_HEIGHT,
      minWidth: TABLE_IMAGE_WIDTH,
      // TODO maybe responsive in the future
      // width: '80vw',
      // height: 'calc(80vw * 1.22)',
    },
    neonTable: {
      //  *** original:
      // width: TABLE_IMAGE_WIDTH,
      // height: TABLE_IMAGE_HEIGHT,
      // position: 'absolute',
      // top: '0px',
      // left: '-58px',
      width: TABLE_IMAGE_WIDTH,
      height: TABLE_IMAGE_HEIGHT,
      position: 'absolute',
      top: '0px',
    },
    tableLogo: {
      position: 'absolute',
      top: '42%',
      left: '50%',
      width: 116,
      transform: 'translate(-50%, 0%)',
    },
    roomInfoArea: {
      position: 'absolute',
      top: '26%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    cardsOnTable: {
      // background:'red',
      // TODO
      // width: '74%',
      width: '65%',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      // height: '50px',
      position: 'absolute',
      top: 212,
      zIndex: ACTION_BUTTON_Z_INDEX.COMMUNITY_CARD,
      // TODO
      // left: '50%',
      left: '54%',
      transform: 'translate(-50%, 0)',
      // TODO
      '& article': {
        // background: 'red',
        marginRight: '2.5px',
      },
      // '& article:not(:first-child)': {
      //   // background: 'red',
      //   marginLeft: '-5px',
      // },
    },
    dealerButton: {
      position: 'absolute',
      zIndex: 2, // under win rate
      width: 20,
      height: 20,
      backgroundColor: '#FFF0C6',
      boxShadow: 'inset 0px -2px 0px #D0B25B;',
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      '&.position_0': {top: 'calc(100% - 142px)', left: '25%'},
      '&.position_1': {top: 'calc(100% - 262px)', left: '27.5%'},
      '&.position_2': {top: '92px', left: '27.5%'},
      '&.position_3': {top: '58px', left: '35.5%'},
      '&.position_4': {top: '82px', left: 'calc(100% - 27.5%)'},
      '&.position_5': {top: 'calc(100% - 260px)', left: 'calc(100% - 28.5%)'},
      '&.hidden': {
        display: 'none',
      },
      transition: 'top 0.3s ease, left 0.3s ease, opacity 0.3s ease',
    },
    dealerLabel: {
      width: 10,
      height: 10,
      position: 'relative',
      top: 3.5,
    },
    topLeftBackground: {
      width: 135,
      height: 161,
      left: '10px',
      position: 'absolute',
    },
    topMiddle: {
      ...commonPlayerStyle,
      position: 'absolute',
      // *** have to give space for -
      // right: 'calc(50% - 35px)',
      // considering the width of the chip
      right: '40%',

      top: '-1%',
      // '& > button': {
      //   transform: 'translateX(15px)',
      // },
    },
    middleLeftBackground: {
      width: 125,
      height: 138,
      position: 'absolute',
      top: '30%',
      left: '10px',
    },
    middleLeft: {
      ...commonPlayerStyle,
      position: 'absolute',
      top: '17.5%',
      left: '8%',
    },
    bottomLeftBackground: {
      width: 103,
      height: 140,
      position: 'absolute',
      bottom: '10%',
      left: '10px',
    },
    bottomLeft: {
      ...commonPlayerStyle,
      position: 'absolute',
      left: '8%',
      top: '51.21%',
    },
    bottomMiddleBackground: {
      width: 149,
      height: 124,
      position: 'absolute',
      bottom: '-10px',
      right: '22%',
    },
    bottomMiddle: {
      ...commonPlayerStyle,
      position: 'absolute',
      left: '10%',
      // bottom: '1%',
      top: '75.79%',
      zIndex: 2,
    },
    middleRightBackground: {
      width: 106,
      height: 146,
      position: 'absolute',
      // border:'1px blue solid',
      right: '15px',
      top: '35%',
    },
    middleRight: {
      ...commonPlayerStyle,
      position: 'absolute',
      right: '8%',
      top: '17.5%',
    },
    bottomRight: {
      ...commonPlayerStyle,
      position: 'absolute',
      right: '8%',
      top: '51.21%',
    },
    emojiTargetSelector: {
      position: 'absolute',
      width: TABLE_WIDTH + EMOJI_SELECTOR_OFFSET.WIDTH,
      height: TABLE_HEIGHT + EMOJI_SELECTOR_OFFSET.HEIGHT,
      zIndex: ACTION_BUTTON_Z_INDEX.EMOJI_TARGET_SELECT_BACKDROP,
    },
    emojiTargetSelectorBody: {
      // *** for debug
      background: '#30bba752',
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    emojiTargetDescription: {
      height: 44,
      marginTop: '100%',
      background:
        // eslint-disable-next-line max-len
        'radial-gradient(#969696, #505050E6, #1F002933)',
      width: '100%',
      textAlign: 'center',
      lineHeight: '44px',
    },
    emojiTargetArea: {
      width: 70,
      height: 100,
    },
    emojiTargetCancelButton: {
      marginTop: 10,
      marginBottom: 40,
    },
    targetButton: {
      width: 70,
      height: 100,
      background: 'transparent',
      color: 'transparent',
      position: 'absolute',
      '&:hover': {
        color: 'transparent',
        background: 'transparent',
      },
    },
    emojiTargetButton: {
      color: 'transparent',
      background: 'transparent',
      '&:hover': {
        color: 'transparent',
        background: 'transparent',
      },
      position: 'absolute',
      '&.position0': {
        left: 132,
        bottom: -70,
        extend: 'emojiTargetArea',
      },
      '&.position1': {
        left: -10,
        bottom: 102,
        extend: 'emojiTargetArea',
      },
      '&.position2': {
        left: -7,
        bottom: 313,
        extend: 'emojiTargetArea',
      },
      '&.position3': {
        top: -23,
        left: 133,
        extend: 'emojiTargetArea',
      },
      '&.position4': {
        bottom: 313,
        right: -5,
        extend: 'emojiTargetArea',
      },
      '&.position5': {
        bottom: 102,
        right: -10,
        extend: 'emojiTargetArea',
      },
    },
    shootingEmojiContainer: {
      position: 'absolute',
      transform: 'translate(0, 0)',
      transition: 'transform 0s ease-out',
      zIndex: ACTION_BUTTON_Z_INDEX.EMOJI_CONTAINER,
      pointerEvents: 'none',
    },
    hidden: {
      visibility: 'hidden',
    },
    isAnimating: {
      transition: `transform ${EMOJI_TRANSITION_DURATION}ms ease-out`,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
